import { Modal, Tag } from 'antd';
import styles from './index.module.sass';
import {
  $selectedLeftWh,
  $selectedRightWh,
  toggleLeftWh,
  toggleRightWh,
  toggleSelectWarehouse,
} from '@/widgets/storage-viewer/model';
import { unmixBag } from '../edit-bag/model';
import { useStore } from 'effector-react';
import { $mixedBags } from '@/entities/simple-mix/model';
import { removeBag as removeBagEvent } from '@/entities/simple-mix/model';
import { CloseOutlined } from '@ant-design/icons';

export const StorageSelectedBags = () => {
  const mixedBags = useStore($mixedBags);

  const leftWhId = useStore($selectedLeftWh);
  const rightWhId = useStore($selectedRightWh);

  const confirmFoo = (fn: () => void) => {
    Modal.confirm({
      title: 'Подтвердите действие',
      content: 'Вы действительно хотите убрать данный компонент из миксования?',
      okText: 'Да',
      cancelText: 'Нет',
      onOk: () => fn(),
    });
  };

  const removeRightBag = () => {
    if (mixedBags[1]) unmixBag({ bagId: String(mixedBags[1]) });
    toggleRightWh(null);
    removeBagEvent('right');
    localStorage.removeItem('bag_b_initial_state');
    localStorage.removeItem('bagB');
  };
  const removeLeftBag = () => {
    if (mixedBags[0]) unmixBag({ bagId: String(mixedBags[0]) });
    toggleLeftWh(null);
    removeBagEvent('left');
    localStorage.removeItem('bag_a_initial_state');
    localStorage.removeItem('bagA');
  };

  const cutWhName = (val?: string) => {
    if (val && val.length > 15) {
      return `${val.substring(0, 15)}...`;
    }
    return val;
  };

  return (
    <div className={styles.root}>
      <span>Выбрано к миксованию:</span>
      {mixedBags[0] && (
        <Tag
          color="rgb(200, 231, 255)"
          style={{
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
            color: 'rgb(8, 112, 226)',
            // display: 'flex',
            // alignItems: 'center',
            // padding: '3px 5px'
          }}
          closeIcon={
            <CloseOutlined style={{ color: 'rgb(8, 112, 226)' }} rev={undefined} />
          }
          closable={true}
          onClose={(e) => {
            e.preventDefault();
            confirmFoo(removeLeftBag);
          }}
          onClick={() => leftWhId && toggleSelectWarehouse(leftWhId?.id)}
        >
          {cutWhName(leftWhId?.name)} | {`${mixedBags[0]}`}
        </Tag>
      )}
      {mixedBags[1] && (
        <Tag
          color="rgb(255, 234, 235)"
          style={{
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
            color: 'rgb(231, 58, 66)',
          }}
          closeIcon={
            <CloseOutlined style={{ color: 'rgb(231, 58, 66)' }} rev={undefined} />
          }
          closable={true}
          onClose={(e) => {
            e.preventDefault();
            confirmFoo(removeRightBag);
          }}
          onClick={() => rightWhId && toggleSelectWarehouse(rightWhId?.id)}
        >
          {cutWhName(rightWhId?.name)} | {`${mixedBags[1]}`}
        </Tag>
      )}
    </div>
  );
};

function Arrow({ color }: { color: string }) {
  return (
    <svg
      style={{ transform: 'rotate(90deg)' }}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.5 15.75L12 8.25L19.5 15.75"
        stroke={color || "#000"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
